import React, { useState, useRef, useEffect } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";
import { getCountryInfo } from "../../../../../helper/utility";
import { useSelector } from "react-redux";

const geoUrl = "/features.json";

// const RadioTrackMap = ({ zoom, setZoom }) => {
//   const [tooltip, setTooltip] = useState({
//     show: false,
//     content: "",
//     coords: [0, 0],
//   });
//   const [position, setPosition] = useState({ coordinates: [0, 0], zoom: zoom });
//   const [activeMarker, setActiveMarker] = useState(null);
//   const projectionRef = useRef();

//   const reducerData = useSelector((state) => state.dataanalyst);
//     const { trackStatsForMap } = reducerData;
//     const geoData = trackStatsForMap?.audienceData;

//   useEffect(() => {
//     setPosition((pos) => ({ ...pos, zoom }));
//   }, [zoom]);

//   const handleMarkerEvent = (marker, content) => {
//     const proj = projectionRef.current;
//     if (proj) {
//       const [x, y] = proj([marker.longitude, marker.latitude]);
//       setActiveMarker(marker);
//       setTooltip({
//         show: true,
//         content,
//         coords: [x, y],
//       });
//     }
//   };

//   const handleMoveEnd = (position) => {
//     setPosition(position);
//     if (activeMarker && projectionRef.current) {
//       const [x, y] = projectionRef.current([
//         activeMarker.longitude,
//         activeMarker.latitude,
//       ]);
//       setTooltip((prev) => ({
//         ...prev,
//         coords: [x, y],
//       }));
//     }
//   };

//   const handleZoomIn = () => {
//     if (position.zoom >= 8) return;
//     setPosition((pos) => {
//       const newZoom = pos.zoom * 1.5;
//       setZoom(newZoom);
//       return { ...pos, zoom: newZoom };
//     });
//   };

//   const handleZoomOut = () => {
//     if (position.zoom <= 1) return;
//     setPosition((pos) => {
//       const newZoom = pos.zoom / 1.5;
//       setZoom(newZoom);
//       return { ...pos, zoom: newZoom };
//     });
//   };

//   const scale = (value) => Math.sqrt(value || 1) * (2 / (position.zoom || 1));

//   // Add this helper function to calculate total plays for a country including cities
//   const calculateTotalPlaysForCountry = (countryData) => {
//     const cityPlays =
//       countryData?.cities?.reduce(
//         (sum, city) => sum + (city.totalPlays || 0),
//         0
//       ) || 0;
//     return cityPlays + (countryData.totalPlays || 0);
//   };

//   // Update the getCountryColor function to handle combined plays
//   const getCountryColor = (countryData) => {
//     if (!countryData) return "#FFFFFF";
//     const totalPlays = calculateTotalPlaysForCountry(countryData);
//     if (totalPlays > 1000) return "rgba(255, 69, 0, 0.6)";
//     if (totalPlays > 500) return "rgba(255, 140, 0, 0.5)";
//     if (totalPlays > 100) return "rgba(255, 165, 0, 0.4)";
//     return "rgba(255, 200, 124, 0.3)";
//   };

//   const getCityColor = (totalPlays) => {
//     if (totalPlays > 100) return "rgba(255, 69, 0, 0.8)";
//     if (totalPlays > 50) return "rgba(255, 140, 0, 0.8)";
//     if (totalPlays > 10) return "rgba(255, 165, 0, 0.8)";
//     return "rgba(255, 200, 124, 0.8)";
//   };

//   return (
//     <div className="relative">
//       <ComposableMap
//         projection="geoMercator"
//         projectionConfig={{ scale: 90 }}
//         ref={projectionRef}
//       >
//         <ZoomableGroup
//           zoom={position.zoom}
//           center={position.coordinates}
//           onMoveStart={() => setTooltip((prev) => ({ ...prev, show: false }))}
//           onMoveEnd={handleMoveEnd}
//           maxZoom={8}
//           dragging={false}
//           onWheelZoom={(e) => {
//             if (e.deltaY < 0) handleZoomIn();
//             else handleZoomOut();
//           }}
//         >
//           <Geographies geography={geoUrl}>
//             {({ geographies, projection }) => {
//               projectionRef.current = projection;
//               return geographies.map((geo) => {
//                 const countryCode = geoData?.topCountry;
//                 const countryName = getCountryInfo(countryCode).name;

//                 if (geo.properties.name !== countryName) {
//                   return (
//                     <Geography
//                       key={geo.rsmKey}
//                       geography={geo}
//                       fill="#fff"
//                       stroke="#fe3d00"
//                       strokeWidth={0.7}
//                       style={{ default: { outline: "none" } }}
//                     />
//                   );
//                 }

//                 return (
//                   <Geography
//                     key={geo.rsmKey}
//                     geography={geo}
//                     fill={getCountryColor(geoData)}
//                     stroke="#fe3d00"
//                     strokeWidth={0.85}
//                     style={{
//                       default: { outline: "none", cursor: "pointer" },
//                       hover: { fill: "rgba(255, 69, 0, 0.7)" },
//                       pressed: { outline: "none" },
//                     }}
//                     onMouseEnter={(evt) => {
//                       const bounds = evt.target.getBoundingClientRect();
//                       const x = bounds.left + bounds.width / 2;
//                       const y = bounds.top;

//                       const totalPlays =
//                         calculateTotalPlaysForCountry(geoData);

//                       setTooltip({
//                         show: true,
//                         content: `${
//                           getCountryInfo(countryCode).flag
//                         } ${countryName}
// 🎧 Total Plays: ${totalPlays.toLocaleString()}
// 📡 Stations: ${geoData.totalStations}
// ⭐ Track: ${geoData.topTrack?.track_name || "-"}
// 🏆 Top Station: ${geoData.topStation?.name || "-"}`,
//                         coords: [x, y],
//                       });
//                     }}
//                     onMouseMove={(evt) => {
//                       const bounds = evt.target.getBoundingClientRect();
//                       const x = bounds.left + bounds.width / 2;
//                       const y = bounds.top;

//                       setTooltip((prev) => ({ ...prev, coords: [x, y] }));
//                     }}
//                     onMouseLeave={() =>
//                       setTooltip((prev) => ({ ...prev, show: false }))
//                     }
//                     // ...existing onMouseMove and onMouseLeave handlers
//                   />
//                 );
//               });
//             }}
//           </Geographies>

//           {/* City markers */}
//           {geoData?.cities?.map((city, idx) => {
//             if (!city.city_lat || !city.city_lng) return null;
//             return (
//               <Marker
//                 key={`${geoData?.topCountry}-${idx}`}
//                 coordinates={[
//                   parseFloat(city.city_lng),
//                   parseFloat(city.city_lat),
//                 ]}
//                 onMouseEnter={() =>
//                   handleMarkerEvent(
//                     {
//                       longitude: city.city_lng,
//                       latitude: city.city_lat,
//                     },
//                     `🏙️ ${city.city_name || "Unknown"}, ${
//                       getCountryInfo(city.country_code).name
//                     }
// 🎧 ${city.totalPlays} Plays
// 📡 Station: ${geoData.topStation?.name || "-"}
// ⭐ Track: ${geoData.topTrack?.track_name || "-"}
// 🏆 Top Station: ${geoData.topStation?.name || "-"}`
//                   )
//                 }
//                 onMouseLeave={() =>
//                   setTooltip((prev) => ({ ...prev, show: false }))
//                 }
//               >
//                 <circle
//                   r={scale(city.totalPlays)}
//                   fill={getCityColor(city.totalPlays)}
//                   stroke="#ff0000"
//                   strokeWidth={0.8}
//                   style={{ transition: "all 300ms", cursor: "pointer" }}
//                 />
//               </Marker>
//             );
//           })}
//         </ZoomableGroup>
//       </ComposableMap>

//       {/* Tooltip */}
//       {tooltip.show && (
//         <div
//           className="absolute bg-white px-3 py-2 rounded-lg shadow-lg text-sm text-gray-700 pointer-events-none z-50 border border-gray-200"
//           style={{
//             left: `${tooltip.coords[0]}px`,
//             top: `${tooltip.coords[1]}px`,
//             transform: "translate(-50%, -120%)",
//             whiteSpace: "pre-line",
//             minWidth: "200px",
//             backdropFilter: "blur(8px)",
//             backgroundColor: "rgba(255, 255, 255, 0.95)",
//           }}
//         >
//           {tooltip.content}
//         </div>
//       )}
//     </div>
//   );
// };

const RadioTrackMap = ({ zoom, setZoom }) => {
  const [tooltip, setTooltip] = useState({
    show: false,
    content: "",
    coords: [0, 0],
  });
  const [position, setPosition] = useState({ coordinates: [0, 0], zoom: zoom });
  const [activeMarker, setActiveMarker] = useState(null);
  const projectionRef = useRef();

  const reducerData = useSelector((state) => state.dataanalyst);
  const { trackStatsForMap } = reducerData;
  const geoData = trackStatsForMap?.audienceData;

  useEffect(() => {
    setPosition((pos) => ({ ...pos, zoom }));
  }, [zoom]);

  const handleMarkerEvent = (marker, content) => {
    const proj = projectionRef.current;
    if (proj) {
      const [x, y] = proj([marker.longitude, marker.latitude]);
      setActiveMarker(marker);
      setTooltip({
        show: true,
        content,
        coords: [x, y],
      });
    }
  };

  const handleMoveEnd = (position) => {
    setPosition(position);
    setZoom(position.zoom); // Sync zoom with parent
    if (activeMarker && projectionRef.current) {
      const [x, y] = projectionRef.current([
        activeMarker.longitude,
        activeMarker.latitude,
      ]);
      setTooltip((prev) => ({
        ...prev,
        coords: [x, y],
      }));
    }
  };

  const handleZoomIn = () => {
    if (position.zoom >= 8) return;
    setPosition((pos) => {
      const newZoom = pos.zoom * 1.5;
      setZoom(newZoom);
      return { ...pos, zoom: newZoom };
    });
  };

  const handleZoomOut = () => {
    if (position.zoom <= 1) return;
    setPosition((pos) => {
      const newZoom = pos.zoom / 1.5;
      setZoom(newZoom);
      return { ...pos, zoom: newZoom };
    });
  };

  const scale = (value) => Math.sqrt(value || 1) * (2 / (position.zoom || 1));

  // Add this helper function to calculate total plays for a country including cities
  const calculateTotalPlaysForCountry = (countryData) => {
    const cityPlays =
      countryData?.cities?.reduce(
        (sum, city) => sum + (city.totalPlays || 0),
        0
      ) || 0;
    return cityPlays + (countryData.totalPlays || 0);
  };

  // Update the getCountryColor function to handle combined plays
  const getCountryColor = (countryData) => {
    if (!countryData) return "#FFFFFF";
    const totalPlays = calculateTotalPlaysForCountry(countryData);
    if (totalPlays > 1000) return "rgba(255, 69, 0, 0.6)";
    if (totalPlays > 500) return "rgba(255, 140, 0, 0.5)";
    if (totalPlays > 100) return "rgba(255, 165, 0, 0.4)";
    return "rgba(255, 200, 124, 0.3)";
  };

  const getCityColor = (totalPlays) => {
    if (totalPlays > 100) return "rgba(255, 69, 0, 0.8)";
    if (totalPlays > 50) return "rgba(255, 140, 0, 0.8)";
    if (totalPlays > 10) return "rgba(255, 165, 0, 0.8)";
    return "rgba(255, 200, 124, 0.8)";
  };

  return (
    <div className="relative">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 90 }}
        ref={projectionRef}
      >
        <ZoomableGroup
          zoom={position.zoom}
          center={position.coordinates}
          onMoveStart={() => setTooltip((prev) => ({ ...prev, show: false }))}
          onMoveEnd={handleMoveEnd}
          // minZoom={1}
          maxZoom={200}
        >
          <Geographies geography={geoUrl}>
            {({ geographies, projection }) => {
              projectionRef.current = projection;
              return geographies.map((geo) => {
                const countryCode = geoData?.topCountry;
                const countryName = getCountryInfo(countryCode).name;

                if (geo.properties.name !== countryName) {
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill="#fff"
                      stroke="#fe3d00"
                      strokeWidth={0.7}
                      style={{ default: { outline: "none" } }}
                    />
                  );
                }

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={getCountryColor(geoData)}
                    stroke="#fe3d00"
                    strokeWidth={0.85}
                    style={{
                      default: { outline: "none", cursor: "pointer" },
                      hover: { fill: "rgba(255, 69, 0, 0.7)" },
                      pressed: { outline: "none" },
                    }}
                    onMouseEnter={(evt) => {
                      const bounds = evt.target.getBoundingClientRect();
                      const x = bounds.left + bounds.width / 2;
                      const y = bounds.top;

                      const totalPlays =
                        calculateTotalPlaysForCountry(geoData);

                      setTooltip({
                        show: true,
                        content: `${
                          getCountryInfo(countryCode).flag
                        } ${countryName}
🎧 Total Plays: ${totalPlays.toLocaleString()}
📡 Stations: ${geoData.totalStations}
⭐ Track: ${geoData.topTrack?.track_name || "-"}
🏆 Top Station: ${geoData.topStation?.name || "-"}`,
                        coords: [x, y],
                      });
                    }}
                    onMouseMove={(evt) => {
                      const bounds = evt.target.getBoundingClientRect();
                      const x = bounds.left + bounds.width / 2;
                      const y = bounds.top;

                      setTooltip((prev) => ({ ...prev, coords: [x, y] }));
                    }}
                    onMouseLeave={() =>
                      setTooltip((prev) => ({ ...prev, show: false }))
                    }
                  />
                );
              });
            }}
          </Geographies>

          {/* City markers */}
          {geoData?.cities?.map((city, idx) => {
            if (!city.city_lat || !city.city_lng) return null;
            return (
              <Marker
                key={`${geoData?.topCountry}-${idx}`}
                coordinates={[
                  parseFloat(city.city_lng),
                  parseFloat(city.city_lat),
                ]}
                onMouseEnter={() =>
                  handleMarkerEvent(
                    {
                      longitude: city.city_lng,
                      latitude: city.city_lat,
                    },
                    `🏙️ ${city.city_name || "Unknown"}, ${
                      getCountryInfo(city.country_code).name
                    }
🎧 ${city.totalPlays} Plays
📡 Station: ${geoData.topStation?.name || "-"}
⭐ Track: ${geoData.topTrack?.track_name || "-"}
🏆 Top Station: ${geoData.topStation?.name || "-"}`
                  )
                }
                onMouseLeave={() =>
                  setTooltip((prev) => ({ ...prev, show: false }))
                }
              >
                <circle
                  r={scale(city.totalPlays)}
                  fill={getCityColor(city.totalPlays)}
                  stroke="#ff0000"
                  strokeWidth={0.8}
                  style={{ transition: "all 300ms", cursor: "pointer" }}
                />
              </Marker>
            );
          })}
        </ZoomableGroup>
      </ComposableMap>

      {/* Tooltip */}
      {tooltip.show && (
        <div
          className="absolute bg-white px-3 py-2 rounded-lg shadow-lg text-sm text-gray-700 pointer-events-none z-50 border border-gray-200"
          style={{
            left: `${tooltip.coords[0]}px`,
            top: `${tooltip.coords[1]}px`,
            transform: "translate(-50%, -120%)",
            whiteSpace: "pre-line",
            minWidth: "200px",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
          }}
        >
          {tooltip.content}
        </div>
      )}
    </div>
  );
};

export default RadioTrackMap;
